import FalconCloseButton from "components/common/FalconCloseButton";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

const DeleteConfirm=({ title, message, onConfirm, onCancel})=>{

  return (
    <>
      <Modal
        show={true}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <FalconCloseButton onClick={onCancel} />
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCancel}>
            No
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteConfirm;